import type { ReactNode } from 'react';

export type StatusTone = 'success' | 'info' | 'warning' | 'danger' | 'ai' | 'neutral';

export function StatusPill({ tone = 'neutral', children }: { tone?: StatusTone; children: ReactNode }) {
  return <span className={`altios-status-pill altios-status-pill--${tone}`}>{children}</span>;
}
